import { ApplicationApiTagTypes, ApplicationApiUrls } from "@/modules/application/common/enum";
import type {
  IAccountClosureApplication,
  ICreateAccountClosureApplicationRequest,
  IUpdateAccountClosureApplicationRequest,
} from "@/modules/application/common/types";
import { withIdempotency } from "@/shared/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "app/axios";

export const accountClosureApplicationApi = createApi({
  reducerPath: "accountClosureApplicationApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: [ApplicationApiTagTypes.ApplicationHistory],
  endpoints: (builder) => ({
    createAccountClosureApplication: builder.mutation<string, ICreateAccountClosureApplicationRequest>(
      withIdempotency<ICreateAccountClosureApplicationRequest>(
        ApplicationApiUrls.AccountClosure
      )),
    updateAccountClosureApplication: builder.mutation<string, IUpdateAccountClosureApplicationRequest>(
      {
        query: ({ data, id }) => ({
          url: `${ApplicationApiUrls.AccountClosure}/${id}`,
          method: "PUT",
          data,
        }),
      }),
    getAccountClosureApplication: builder.query<IAccountClosureApplication, {
      id: string
    }>({
      query: ({ id }) => ({
        url: `${ApplicationApiUrls.AccountClosure}/${id}`,
      }),
    }),
  }),
});

export const {
  useGetAccountClosureApplicationQuery,
  useCreateAccountClosureApplicationMutation,
  useUpdateAccountClosureApplicationMutation,
} = accountClosureApplicationApi;
